export enum FormControlType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  SELECT = 'select',
  AUTOCOMPLETE = 'autocomplete',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  DATEPICKER = 'datepicker',
  DATE_RANGE_PICKER = 'date_range_picker',
  FILE = 'file',
  DYNAMIC_COMPONENT = 'dynamic_component',
  SWITCH = 'switch'
}

export enum SELECT_TYPE {
  FILE = 'file',
  IMAGE = 'image'
}

export enum SCREEN_SIZE {
  // Extra small is none
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
  EXTRA_LARGE = 'xl'
}

export enum DIRECTION {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  INSIDE = 'inside'
}

export enum Align {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}

export enum TableDataType {
  HTML = 'html',
  DYNAMIC_COMPONENT = 'dynamic_component'
}

export enum TableLayout {
  CLASSIC = 'classic',
  MODERN = 'modern'
}

export enum FilterType {
  NONE = 'none',
  TEXT = 'text',
  DATE = 'date',
  DATE_RANGE = 'date_range',
  NUMBER = 'number',
  SELECT = 'select',
  MULTI_SELECT = 'multi_select',
  BOOLEAN = 'boolean',
  RESET = 'reset-all', // reset all column filter
  CUSTOM = 'custom' // custom filter, for example: select filter
}

export enum TableEvent {
  RIGHT_CLICK_CELL,
  TOGGLE_EXPANDED,
  UPDATE_MAXLEVEL
}

export enum VALIDATE_IMAGE {
  MAX_FILE_SIZE = 2 * 1024 * 1024, // 2MB
  MIN_DIMENSION = 150, // 150x150 pixels
  MAX_DIMENSION = 1000 // 1000x1000 pixels
}

export enum DateFormat {
  TIME = 'HH:mm',
  DATE = 'dd.MM.yyyy',
  UTC_DATE = 'YYYY-MM-DD',
  DATE_TIME = 'dd.MM.yyyy HH:mm'
}

export enum TextFormat {
  DAY = 'day',
  TIME = 'time',
  DECIMAL = 'decimal',
  DATE_TIME_ZONE = 'timezone'
}

export enum INDICATOR_TYPE {
  ReCiPe,
  EF31
}
